module.exports = __webpack_public_path__ + "img/smartHome-xs.db957aee.jpg";